"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M14.132 16.9747L10.5786 20.5281C8.61616 22.4906 5.43435 22.4906 3.47186 20.5281C1.50938 18.5657 1.50938 15.3838 3.47186 13.4214L7.02525 9.86797M16.9747 14.132L20.5281 10.5786C22.4906 8.61616 22.4906 5.43435 20.5281 3.47186C18.5657 1.50938 15.3838 1.50938 13.4214 3.47186L9.86797 7.02525", stroke: "black", strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M16.9852 7.0564L7.05641 16.9852", stroke: "black", strokeWidth: "1", strokeLinecap: "round" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M18.9848 22.9646L14.0101 27.9394C11.2626 30.6869 6.80808 30.6869 4.06061 27.9394C1.31313 25.1919 1.31313 20.7374 4.06061 17.9899L9.03535 13.0152M22.9646 18.9848L27.9394 14.0101C30.6869 11.2626 30.6869 6.80808 27.9394 4.06061C25.1919 1.31313 20.7374 1.31313 17.9899 4.06061L13.0152 9.03535", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M22.9793 9.07898L9.079 22.9793", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round" }, void 0)] }), void 0));
};
var AttachmentIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.AttachmentIcon = AttachmentIcon;
//# sourceMappingURL=AttachmentIcon.js.map